export const SUCCESS = true;
export const FAILED = false;
export const UNSET = null;

export const GET_USERS = "GET_USERS";
export const API_ERROR = "API_ERROR";
export const API_UNAUTHORIZED = "API_UNAUTHORIZED";

export const LOADING_START = "LOADING_START";
export const LOADING_SUCCESS = "LOADING_SUCCESS";
export const LOADING_FAIL = "LOADING_FAIL";

export const ON_LOGO_CLICK = "ON_LOGO_CLICK";

export const ON_CHECK_TOKEN = "ON_CHECK_TOKEN";
export const SET_TOKEN_STATUS = "SET_TOKEN_STATUS";
export const SET_COMPLETED = "[ui action] SET_COMPLETED"
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const SET_STEPS = "SET_STEPS";

export const DISMISS_ERROR = "DISMISS_ERROR";
export const ON_ERROR = "ON_ERROR";
export const RESET_STATUS = "RESET_STATUS";

//Authentication
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_RESET = "AUTH_RESET";

export const SET_SPLASH_WAIT = "[internal process] SET_SPLASH_WAIT";
export const RESET_SPLASH_WAIT = "[internal process] RESET_SPLASH_WAIT";

export const ON_NEED_LOGIN_POPUP = "[internal process] ON_NEED_LOGIN_POPUP";
export const ON_CANCEL_AUTHENTICATION = "[internal process] ON_CANCEL_AUTHENTICATION";
export const ON_SUBMIT_PAYMENT_PLAN = "[internal process] ON_SUBMIT_PAYMENT_PLAN";
export const API_PAYMENT_PLAN_START = "[api request] PAYMENT_PLAN_START"
export const API_PAYMENT_PLAN_SUCCESS = "[api request] PAYMENT_PLAN_SUCCESS"
export const API_PAYMENT_PLAN_FAIL = "[api request] PAYMENT_PLAN_FAIL"

export const SET_PAYMENT_METHOD = "[ui action] SET_PAYMENT_METHOD";
export const ON_AGREE_TO_TERMS = "[ui action] ON_AGREE_TO_TERMS";
export const ON_AGREE_DEBIT_TERMS = "[ui action] ON_AGREE_DEBIT_TERMS";
export const ON_AGREE_ARRANGE_FUND = "[ui action] ON_AGREE_ARRANGE_FUND";
export const ON_CONSENT = "[ui action] ON_CONSENT";
export const ON_SUBMIT_PAYMENT = "[ui action] ON_SUBMIT_PAYMENT"
export const API_PAYMENT_START = "[api request] PAYMENT_START"
export const API_PAYMENT_SUCCESS = "[api request] PAYMENT_SUCCESS"
export const API_PAYMENT_FAIL = "[api request] PAYMENT_FAIL"

export const ON_CONFIRM_PAYMENT = "[internal process] ON_CONFIRM_PAYMENT";
export const ON_CANCEL_CONFIRM_PAYMENT = "[internal process] ON_CANCEL_CONFIRM_PAYMENT";
export const ON_CLOSE_FEEDBACK = "[internal process] ON_CLOSE_FEEDBACK";

export const ON_CANCEL_PAYWAY = "[internal process] ON_CANCEL_PAYWAY";
export const PAYWAY_TRANSACT_ERROR = "[internal process] PAYWAY_TRANSACT_ERROR";
export const ON_CONTINUE_THANK_YOU = "[internal process] ON_CONTINUE_THANK_YOU";
export const API_PAYWAY_REFERENCE_START = "[api request] PAYWAY_REFERENCE_START"
export const API_PAYWAY_REFERENCE_SUCCESS = "[api request] PAYWAY_REFERENCE_SUCCESS"
export const API_PAYWAY_REFERENCE_FAIL = "[api request] PAYWAY_REFERENCE_FAIL"
export const ON_PROCEED_RESET = "[internal process] ON_PROCEED_RESET";

export const API_EMAIL_VALIDATION_START = "[api request] EMAIL_VALIDATION_START"
export const API_EMAIL_VALIDATION_SUCCESS = "[api request] EMAIL_VALIDATION_SUCCESS"
export const API_EMAIL_VALIDATION_FAIL = "[api request] EMAIL_VALIDATION_FAIL"
export const API_MOBILE_VALIDATION_START = "[api request] MOBILE_VALIDATION_START"
export const API_MOBILE_VALIDATION_SUCCESS = "[api request] MOBILE_VALIDATION_SUCCESS"
export const API_MOBILE_VALIDATION_FAIL = "[api request] MOBILE_VALIDATION_FAIL"
export const VALID_STATUS_EMAIL = "[internal process] VALID_STATUS_EMAIL"
export const VALID_STATUS_MOBILE = "[internal process] VALID_STATUS_MOBILE"

export const SET_PAYMENT_FRAME = "[ui action] SET_PAYMENT_FRAME";
export const SET_PAYMENT_TOKEN = "[ui action] SET_PAYMENT_TOKEN";
